import Cookie from '@/services/cookie'
// import { useUsersStore } from '@/stores/users'

function mountLoadInternal(link, mode) {
    try {
        const representationToken = Cookie.getToken('_chat_auth_representation')
        if (representationToken) {
            console.warn('[INTERNAL CHAT] Representation token detected, ignoring load')
            return
        }

        const scriptId = 'script-internal-chat-' + mode
        const hasLoaded = document.getElementById(scriptId)

        if (hasLoaded) return

        const script = document.createElement('script')
        script.setAttribute('id', scriptId)
        script.setAttribute('onload', `init()`)
        script.defer = true
        script.async = true
        script.setAttribute('src', link)
        document.head.appendChild(script)
    } catch (error) {
        console.error(error)
    }
}

function mountLoadAuditInternal(link, mode) {
    try {
        const representationToken = Cookie.getToken('_chat_auth_representation')
        if (representationToken) {
            console.warn('[INTERNAL CHAT] Representation token detected, ignoring load')
            return
        }
        let token = Cookie.getToken('_chat_auth')
        // remove de token o prefixo Bearer
        token = token.replace('Bearer ', '')
        const scriptId = 'script-internal-chat-' + mode
        const hasLoaded = document.getElementById(scriptId)

        if (hasLoaded) return

        const script = document.createElement('script')
        script.setAttribute('id', scriptId)
        script.setAttribute('onload', `init('${token}')`)
        script.defer = true
        script.async = true
        script.setAttribute('src', link)
        document.head.appendChild(script)
    } catch (error) {
        console.error(error)
    }
}

export function removeInternalChat() {
    const hasLoaded = document.getElementById('internalChat-iframe')
    if (hasLoaded) {
        hasLoaded.remove()
    }

}

export function loadInternalChat(type = 'button') {

    let useUrl = null
    const accessLocal = location.hostname === 'localhost' || location.hostname === '127.0.0.1'

    switch (type) {
        case 'button':
            useUrl = `${window.origin}/_widgets/internal.js`

            if (accessLocal) useUrl = 'https://vmix.chatmix.com.br/_widgets/internal.js'
            break

        case 'full':
            useUrl = `${window.origin}/_widgets/internalFull.js`

            if (accessLocal) useUrl = 'https://vmix.chatmix.com.br/_widgets/internalFull.js'
            break
        case 'audit':
            useUrl = `${window.origin}/_widgets/internalAudit.js`
            if (accessLocal) useUrl = 'https://vmix.chatmix.com.br/_widgets/internalAudit.js'

            break
        default:
            console.error('Invalid mode')
            return
    }

    mountLoadInternal(useUrl, type)
}
